<!-- <div class="auth-main particles_js" [style]="theme">
    <div class="auth_div vivify popIn">
        <div class="auth_brand">
            <a class="navbar-brand" href="javascript:void(0);"><img [src]="logo" width="30" height="30"
                    class="d-inline-block align-top mr-2" alt="">{{title}}</a>
        </div>
        <div class="card">
            <div class="body" style="background-color:#f3f3f3">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <div id="particles-js"></div>
</div> -->


<!-- <div class="main-bg"> -->
<div [ngStyle]="{'background-color': theme_color}">
    <div class="container">
        <section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-6 col-md-8 d-flex flex-column align-items-center justify-content-center">

                        <div class="d-flex justify-content-center py-3">
                            <a href="javascript:void()" class="logo d-flex align-items-center w-auto">
                                <img [src]="profile" [alt]="title" width="200" height="100">
                            </a>
                        </div><!-- End Logo -->
                        <span style="font-size: large;" class="mb-2 text-white d-lg-block"> &nbsp;{{title}}</span>

                        <div class="card mb-3 w-100" style="padding: 1rem !important;">
                            <router-outlet></router-outlet>
                        </div>

                        <div class="credits">
                            Designed by <a target="_blank" href="https://agoo.in">Agoo Technologies</a>
                        </div>

                    </div>
                </div>
            </div>

        </section>

    </div>
</div>